import { Line, LineChart } from 'recharts'

export const ChartTable = ({ data }) => {
  const { trendColor, trendLine } = data

  const dataChart = trendLine.map((item, index) => ({
    dotTrend: item,
    isDot: trendLine.length === index + 1,
  }))

  const CustomizedDot = (props) => {
    const { cx, cy, stroke, payload } = props
    if (payload.isDot) {
      return (
        <svg>
          <foreignObject x={cx - 3} y={cy - 3} width={6} height={6}>
            <div
              className="wh100"
              style={{ backgroundColor: stroke, borderRadius: '50%' }}
            />
          </foreignObject>
        </svg>
      )
    }
    return <></>
  }

  return (
    <>
      <LineChart width={60} height={20} data={dataChart}>
        <Line
          dataKey="dotTrend"
          stroke={trendColor}
          dot={<CustomizedDot />}
          strokeWidth={2}
          isAnimationActive={false}
        />
      </LineChart>
    </>
  )
}
